import React from "react";
import { colorFillScale, domain } from "../utils/scale";
import { LEGEND_FORMAT } from "../config"
// Convert colorScale into legend items and format text where needed.

const items = domain.map(label => {
  let newLabel = label
  // CHECK FORMATTER for potential replacement
  LEGEND_FORMAT.forEach((formatItem) => {
    if (formatItem.label == label) {
      newLabel = formatItem.replace
    }
  })
  return {
    label: newLabel,
    color: colorFillScale(label),
  };
});

const Legend = () => (
  <div className="legend__container">
    <div className="legend__container-inner">
      {items.map((item, i) => (
        <div className={"legend__container-item"} key={item.label}>
          <div
            className={"legend__swatch"}
            style={{ backgroundColor: item.color }}
          />
          <div>{item.label}</div>
        </div>
      ))}
    </div>
  </div>
);

export default Legend;
